import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useLocalStorageState from 'use-local-storage-state';

import { getEnv } from '../../lib/env';

import useDarkMode from '../../hooks/useDarkMode';

import { LifebuoyColorIcon, LifebuoyColorIconWhite } from '../../images/shapes';

export const useHelpCenterMenuItems = () => {
  const { t } = useTranslation();
  const [, setTutorials] = useLocalStorageState('cms.tutorials');
  const [darkMode] = useDarkMode();

  const handleTutorialReset = useCallback(
    async (event) => {
      event.preventDefault();
      setTutorials({ run: true });
    },
    [setTutorials],
  );

  const helpCenterContent = useMemo(() => {
    const links = [];

    if (getEnv('REACT_APP_DOCUMENTATION')) {
      links.push({
        title: t('HelpCenter.Documentation'),
        link: getEnv('REACT_APP_DOCUMENTATION'),
        target: '_blank',
        rel: 'noreferrer',
        key: 'Documentation',
        hidePin: true,
      });
    }

    if (getEnv('REACT_APP_DISCORD')) {
      links.push({
        title: t('HelpCenter.Support'),
        link: getEnv('REACT_APP_DISCORD'),
        target: '_blank',
        rel: 'noreferrer',
        key: 'Support',
        hidePin: true,
      });
    }

    if (getEnv('REACT_APP_DEMO')) {
      links.push({
        title: t('HelpCenter.Demo'),
        link: getEnv('REACT_APP_DEMO'),
        target: '_blank',
        rel: 'noreferrer',
        key: 'Demo',
        hidePin: true,
      });
    }

    if (JSON.parse(getEnv('REACT_APP_ENABLE_TUTORIAL'))) {
      links.push({
        title: t('UserForm.ResetTutorials'),
        key: 'ResetTutorials',
        target: '_self',
        onClick: handleTutorialReset,
        hidePin: true,
      });
    }
    return links;
  }, [t, handleTutorialReset]);

  const helpCenterMenuItems = useMemo(
    () =>
      helpCenterContent.length > 0
        ? [
            {
              key: 'help-center',
              icon: darkMode ? (
                <LifebuoyColorIconWhite className="w-5 min-w-5 ml-0.5" />
              ) : (
                <LifebuoyColorIcon className="w-5 min-w-5 ml-0.5" />
              ),
              title: t('Global.HelpCenter'),
              children: helpCenterContent,
              hidePin: true,
            },
          ]
        : [],
    [helpCenterContent, darkMode, t],
  );

  return { helpCenterMenuItems };
};
